var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-holiday"},[_c('v-select',{staticClass:"select-box",attrs:{"value":_vm.selectedHoliday,"options":_vm.holidayOptions,"placeholder":"選択","clearable":false,"filterable":false},on:{"input":_vm.handleClick},scopedSlots:_vm._u([{key:"no-options",fn:function(){return [_vm._v("-")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }